import { formatCurrency } from '@angular/common';
import { Injectable } from '@angular/core';

import { CURRENCY_LOCALE, CURRENCY_LOCALE_CURRENCY_CODE, CURRENCY_LOCALE_FILE_PATH } from 'app/constants';
import { CurrencyLocaleInfo } from 'app/interfaces';

@Injectable({
    providedIn: 'root',
})
export class CurrencyFormatService {
    private currencyLocale: CurrencyLocaleInfo;

    constructor() {
        this.currencyLocale = {
            currencyCode: CURRENCY_LOCALE_CURRENCY_CODE,
            locale: CURRENCY_LOCALE,
            localeFilePath: CURRENCY_LOCALE_FILE_PATH,
        };
    }

    format(value: number, defaultValue = 0): string {
        const currencySymbol = '€';

        if (!value) {
            value = defaultValue;
        }

        if (typeof value !== 'number') {
            value = parseFloat(value);
        }

        if (this.currencyLocale) {
            return formatCurrency(value, this.currencyLocale.locale, currencySymbol).replace(',', '.');
        }

        return formatCurrency(value, 'et-EE', currencySymbol).replace(',', '.');
    }
}
